import React from 'react';
import { CheckboxHeaderComponentProps } from './checkbox-header-component.types';
import ThreeStateCheckbox from '../../../../components/three-state-checkbox';
import { Flex } from '../../../../common/common-components.styled';

const CheckboxHeaderComponent = ({
  changeCheckboxHandler,
  checkedLeasingOffers,
  massDataLeasingOffersIds
}: CheckboxHeaderComponentProps) => {
  const isChecked = massDataLeasingOffersIds.every(massDataLeasingOffersId =>
    checkedLeasingOffers.includes(massDataLeasingOffersId)
  );
  const isIndeterminate =
    !isChecked &&
    massDataLeasingOffersIds.some(massDataLeasingOffersId => checkedLeasingOffers.includes(massDataLeasingOffersId));

  return (
    <Flex justify='center' width='5%'>
      <ThreeStateCheckbox
        checked={isChecked}
        onChange={() => changeCheckboxHandler(isChecked)}
        indeterminate={isIndeterminate}
      />
    </Flex>
  );
};

export default CheckboxHeaderComponent;
